module.exports = __webpack_public_path__ + "static/media/products_1.4c50c52d.mp4";